import React from 'react';
import { accountService } from '../_services';
import { Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import { useTranslation } from 'react-i18next';


function Contact() {
    const { t } = useTranslation();
    const user = accountService.userValue;
    const guest_services_label = (typeof (accountService.configValue['guestServicesLabel']) !== 'undefined') ? accountService.configValue['guestServicesLabel'] : "Guest Services";
    
    return (
        <div className="card m-3">
            <h2 className="card-header">{t('Help')}</h2>
            <h4 className="card-body col-6">
                {t('help.intro1')} {guest_services_label} {t('help.intro2')}
                </h4>

            <h4 className="card-header card-subheader faq-bor bold-tx">FAQ</h4>
            <Accordion>
                <Card>
                    <Card.Header>
                        <Accordion.Toggle className="ms-pointer" as={Card.Header} variant="link" eventKey="0">
                            {t('help.openQ')}
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>{t('help.openA1')} {guest_services_label} {t('help.openA2')}</Card.Body>
                    </Accordion.Collapse>
                </Card>

                <Card>
                    <Card.Header>
                        <Accordion.Toggle className="ms-pointer" as={Card.Header} variant="link" eventKey="1">
                            {t('help.cleanQ')}
      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="1">
                        <Card.Body>
                            {t('help.cleanA1')} {guest_services_label} {t('help.cleanA2')}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>

                <Card>
                    <Card.Header>
                        <Accordion.Toggle className="ms-pointer" as={Card.Header} variant="link" eventKey="4">
                            {t('help.endedQ')}
      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="4">
                        <Card.Body>
                            {t('help.endedA1')} {guest_services_label} {t('help.endedA2')}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>

                <Card>
                    <Card.Header>
                        <Accordion.Toggle className="ms-pointer" as={Card.Header} variant="link" eventKey="2">
                            {t('help.accessQ')}
      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="2">
                        <Card.Body>
                            {t('help.accessA')}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>

                <Card>
                    <Card.Header>
                        <Accordion.Toggle className="ms-pointer" as={Card.Header} variant="link" eventKey="3">
                            {t('help.paymentQ')}
      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="3">
                        <Card.Body>
                            {t('help.paymentA1')}
<br />
                            {t('help.paymentA2')}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>

                <Card>
                    <Card.Header>
                        <Accordion.Toggle className="ms-pointer" as={Card.Header} variant="link" eventKey="5">
                            {t('help.reservationQ')}
      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="5">
                        <Card.Body>
                            
                            {t('help.reservationA1')}
<br />
                            {t('help.reservationA2')}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>

            </Accordion>

            <h4 className="card-header card-subheader faq-bor bold-tx">{t('Contact')}</h4>
            <h4 className="card-body col-6">
                {t('help.help')}
                </h4>
            <a className="cust-svc-btn" href="tel:1-877-592-0985">
                <h4 className="bold-tx cust-svc-txt">
                    {t('Customer Service')}
            <br />
            1-877-592-0985
            </h4>
            </a>

            <br />

            <a className="cust-svc-btn" href="mailto:customerservice@tiburonlockers.com">
                <h4 className="bold-tx cust-svc-txt">
                    customerservice@
            <br />
            tiburonlockers.com
            </h4>

            </a>

            <div className="cust-ft-top">
                <h3 className="card-header cust-footer">
                    <Link to="/home" className="btn btn-link">{t('Home')}</Link>
                </h3>
            </div>
        </div>
    );
}

export { Contact };